// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__14jL4","question":"Question_question__1ZiBN","description":"Question_description__1mWve"};